<template>
  <span>
    <!-- TVDecoder -->
    <span v-if="device.ctype === 'tv'">
      <v-layout align-center>
        <icon-tv-decoder
          :tvdecoder="device"
          color="msr"
        />
        <small class="ml-2">{{ device.tvformat.name }}</small>
      </v-layout>
    </span>
    <!-- RadioDecoder -->
    <span v-if="device.ctype === 'radio'">
      <v-icon
        color="msr"
        :title="$t('radio')"
        style="margin-bottom: -3px"
      >radio</v-icon>
      <small style="margin-left: 6px">{{ $t('radio') }}</small>
    </span>
    <!-- XovisSensor -->
    <span v-if="device.ctype == 'visitorcount_sensor'">
      <v-icon
        color="msr"
        :title="$t('visitorcount')"
      >timeline</v-icon>
      <small style="margin-left: 6px">{{ $t('visitorcount') }}</small>
    </span>
    <!-- TouchDecoder -->
    <span v-if="device.ctype == 'touch'">
      <v-icon
        color="msr"
        :title="$t('touchDecoder')"
      >touch_app</v-icon>
      <small style="margin-left: 6px">{{ $t('touchDecoder') }}</small>
    </span>
  </span>
</template>

<script>
import IconTvDecoder from '@/components/IconTvDecoder';

export default {
  components: {
    IconTvDecoder,
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceDecodertype.vue